/**
 * formatStringToId: Removes capital letters, symbols and replaces empty spaces
 * @param {string} value - A string that is usually with caps or spaces or symbols
 * @returns {string} Returns a formatted value for an ID attribute
 */
export const formatStringToId = (value = '') => {
  return value
    .toLowerCase()
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .replace(/\s/g, '-');
};

export const composeStringToId = (value = '', componentReference = '') => {
  const formatValue = formatStringToId(value);
  return `${componentReference}-${formatValue}`;
};
